import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
    selector: '[appDropdown]'
})
export class DropdownDirective {
    @HostBinding('class.open') isOpen = false;

    @HostListener('click') toggleOpen() {
        this.isOpen = !this.isOpen;
    }

    @HostListener('mouseenter') onMouseenter() {
        this.isOpen = true;
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.isOpen=false;
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/directives/shared/dropdown.directive.ts